import "./App.css";
import { useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import Hello from "./pages/Hello";
import Counter from "./pages/Counter";
import Temp from "./pages/Temp";
import Fronter from "./pages/Fronter";
import Header from "./components/Headercomponent";
import Login from "./twitter/Login";
import Profile from "./twitter/Profile";
import { UserContextProvider } from "./context/Usercontext";

const PasswordErrorMessage = () => {
  return (
    <p className="FieldError">Password should have at least 8 characters</p>
  );
};

function App() {
  return (
    <UserContextProvider>
      <BrowserRouter>
        <div className="app">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hello" element={<Hello />} />
            <Route path="/counter" element={<Counter />} />
            <Route path="/temp" element={<Temp />} />
            <Route path="/fronter" element={<Fronter />} />
            <Route path="/login" element={<Login />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </div>
      </BrowserRouter>
    </UserContextProvider>
  );
}

export default App;

//////////////
/*
import "./App.css";
import DessertsList from "./DessertsList";
import { useState, useEffect, useRef } from "react";

const desserts = [
  {
    name: "Chocolate Cake",
    calories: 400,
    createdAt: "2022-09-01",
  },
  {
    name: "Ice Cream",
    calories: 200,
    createdAt: "2022-01-02",
  },
  {
    name: "Tiramisu",
    calories: 300,
    createdAt: "2021-10-03",
  },
  {
    name: "Cheesecake",
    calories: 600,
    createdAt: "2022-01-04",
  },
];

function App() {
  return (
    <div className="App">
      <h2>List of low calorie desserts:</h2>
      <DessertsList data={desserts} />
      <Form />
      <Formi />
    </div>
  );
}

const Form = () => {
  const [value, setValue] = useState("");
  const [score, setScore] = useState("");

  let scoreChange = (e) => {
    setScore(e.target.value);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <div>
      <form className="former">
        <label>{value}</label>
        <input value={value} onChange={handleChange} type="text" />
        <label>{score}</label>
        <input
          value={score}
          onChange={scoreChange}
          type="range"
          min="0"
          max="50"
        />
      </form>
    </div>
  );
};

const Formi = () => {
  const fileInput = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const files = fileInput.current.files;
    // Do something with the files here
  };

  return (
    <form onSubmit={handleSubmit}>
      <input ref={fileInput} type="file" />
    </form>
  );
};

export default App;
*/
